module.exports = __webpack_public_path__ + "img/rowanswer.9193abab.png";